/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Invite_Codes_CreatingInputs */

const en_admin_invite_codes_creating = /** @type {(inputs: Admin_Invite_Codes_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creating...`)
};

const zh_admin_invite_codes_creating = /** @type {(inputs: Admin_Invite_Codes_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建中...`)
};

/**
* | output |
* | --- |
* | "Creating..." |
*
* @param {Admin_Invite_Codes_CreatingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_invite_codes_creating = /** @type {((inputs?: Admin_Invite_Codes_CreatingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Invite_Codes_CreatingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_invite_codes_creating(inputs)
	return zh_admin_invite_codes_creating(inputs)
});
export { admin_invite_codes_creating as "admin.invite_codes.creating" }